import { applyMiddleware, createStore } from 'redux';

import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import rootReducer from './reducers';

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(
    thunk,
    // createLogger()
  )
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js